import { Box, ColorOptions, Icon, ModBox, Spacer, Text, TextInputNew, TextInputNewProps } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useState } from 'react'
import { DropdownOptimised } from '../../comps/DropdownNew'
import { Colors } from '../../util/util'

const tenureData = [
  { index: 0, value: '3M' },
  { index: 1, value: '6M' },
  { index: 2, value: '9M' },
  { index: 3, value: '12M' },
  { index: 4, value: '18M' },
  { index: 5, value: '24M' },
]
export const TenureROI = ({
  value,
  setFieldValue,
  fieldName,
  updateRuleConfigError,
  ruleConfigErrors,
  editable,
  rightComponent,
  percentComp,
  tenureComp,
  setTenureRoiArr,
  tenureRoiArr,
  index,
  emiBanksList,
}: any) => {
  const [tenure, setTenure] = useState(value?.tenure?.[index]) // no cost emi
  const [roi, setRoi] = useState(value?.roi?.[index]) // no cost emi
  const [emiBankName, setEmiBankName] = useState(value?.emiBankName?.[index]) // no cost emi
  const getTenure = (val, index) => {
    const data: any = value?.tenure ?? []
    data[index] = val
    return data
  }
  const getRoi = (val, index) => {
    const data: any = value?.roi ?? []
    data[index] = val
    return data
  }
  const deleteRoi = (index) => {
    const data: any = value?.roi ?? []
    delete data[index]
    return data
  }
  const deleteTenure = (index) => {
    const data: any = value?.tenure ?? []
    delete data[index]
    return data
  }
  const getEmiBankName = (val, index) => {
    const data: any = value?.emiBankName ?? []
    data[index] = val
    return data
  }
  const deleteEmiBankName = (index) => {
    const data: any = value?.emiBankName ?? []
    delete data[index]
    return data
  }
  const handleTenureChange = (val: any) => {
    updateRuleConfigError('tenure', null)
    let isValid = false
    if (isEmpty(value?.emiBankName?.[index])) {
      isValid = true
    } else {
      const filtered = value?.emiBankName?.filter(
        (item, i) => item === value?.emiBankName?.[index] && val === value?.tenure?.[i],
      )
      if (filtered?.length > 0) {
        isValid = false
      } else {
        isValid = true
      }
    }
    if (isValid) {
      setTenure(val)
      updateRuleConfigError('tenure', null)
      setFieldValue(fieldName, { ...value, tenure: getTenure(val, index) })
    } else {
      setTenure('')
      updateRuleConfigError('tenure', 'Please select different tenure')
    }
  }

  const handleTenureOnBlur = () => {
    setFieldValue(fieldName, { ...value, tenure: getTenure(tenure, index) })
  }
  const onRoiChange = (val: any) => {
    setRoi(val)
    updateRuleConfigError('roi', null)
  }
  const handleROIOnBlur = () => {
    setFieldValue(fieldName, { ...value, roi: getRoi(roi, index) })
  }

  const handleEmiBankNameChange = (val: any) => {
    updateRuleConfigError('emiBankName', null)
    let isValid = false
    if (isEmpty(value?.tenure?.[index])) {
      isValid = true
    } else {
      const filtered = value?.tenure?.filter(
        (item, i) => item === value?.tenure?.[index] && val === value?.emiBankName?.[i],
      )
      if (filtered?.length > 0) {
        isValid = false
      } else {
        isValid = true
      }
    }
    if (isValid) {
      setEmiBankName(val)
      updateRuleConfigError('emiBankName', null)
      setFieldValue(fieldName, { ...value, emiBankName: getEmiBankName(val, index) })
    } else {
      setEmiBankName('')
      updateRuleConfigError('emiBankName', 'Please select different bank')
    }
  }
  const deleteRow = () => {
    setFieldValue(fieldName, {
      ...value,
      roi: deleteRoi(index),
      tenure: deleteTenure(index),
      emiBankName: deleteEmiBankName(index),
    })
    tenureRoiArr.splice(index, 1, 0)
  }
  const handleIconPress = () => {
    index + 1 === tenureRoiArr?.length ? setTenureRoiArr([...tenureRoiArr, 1]) : deleteRow()
  }
  if (tenureRoiArr?.[index] === 0) {
    return null
  }
  return (
    <Box flexDirection={'row'} h={80} pb={8}>
      <Box f={0.5} h={80}>
        <DropdownOptimised
          label={'EMI Bank *'}
          labelPaddingBottom={8}
          labelColor={Colors.LABEL_GREY as ColorOptions}
          borderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions}
          titleColor={Colors.FONT_GREY as ColorOptions}
          chevronColor={'BLACK_75'}
          labelFontFamily={'jiotype-medium'}
          placeHolder={emiBankName ?? 'Emi Bank'}
          onChange={handleEmiBankNameChange}
          error={index + 1 === tenureRoiArr?.length ? ruleConfigErrors.emiBankName : undefined}
          disabled={!editable}
          disabledBg={'WHITE'}
          touched={true}
          dropdownHeight={200}
          data={emiBanksList}
          testID={'emibankslist-wrapper'}
        />
      </Box>
      <Spacer direction={'horizontal'} size={16} />
      <Box f={0.5} h={80}>
        <DropdownOptimised
          label={'Tenure *'}
          labelPaddingBottom={8}
          labelColor={Colors.LABEL_GREY as ColorOptions}
          borderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions}
          titleColor={Colors.FONT_GREY as ColorOptions}
          chevronColor={'BLACK_75'}
          labelFontFamily={'jiotype-medium'}
          placeHolder={tenure ?? 'Tenure'}
          onChange={handleTenureChange}
          error={index + 1 === tenureRoiArr?.length ? ruleConfigErrors.tenure : undefined}
          disabled={!editable}
          disabledBg={'WHITE'}
          touched={true}
          boxheight={40}
          data={tenureData}
        />
      </Box>
      <Spacer direction={'horizontal'} size={16} />
      <Box f={0.5} h={80}>
        <TextInputNew
          placeholder="Rate of Interest *"
          label="Rate of Interest"
          value={roi}
          onChange={onRoiChange}
          onBlur={handleROIOnBlur}
          fieldName={'roi'}
          editable={editable}
          error={index + 1 === tenureRoiArr?.length ? ruleConfigErrors.roi : undefined}
          touched
          labelPaddingBottom={10}
          minHeight={24}
          rightComponent={editable ? percentComp : rightComponent}
          {...styles.textinputStyle}
        />
      </Box>
      <Spacer direction={'horizontal'} size={16} />
      <ModBox
        show={true}
        onPress={handleIconPress}
        testID="handleRoi"
        accessibilityLabel={index + 1 < tenureRoiArr?.length ? 'delete' : 'add'}
        disabled={!editable}
        underlayColor="TRANSPARENT"
        h={40}
        w={40}
        align={'center'}
        justify={'center'}
        borderRadius={4}
        mt={26}
        bg={Colors.BG_BLUE_LIGHT as ColorOptions}>
        {index + 1 < tenureRoiArr?.length && <Icon id={'DELETE'} color={Colors.BG_BLUE as ColorOptions} size={16} />}
        {index + 1 === tenureRoiArr?.length && (
          <Text title={'+'} color={Colors.BG_BLUE as ColorOptions} fontSize={16} />
        )}
      </ModBox>
    </Box>
  )
}

const styles = {
  textinputStyle: {
    type: 'body12',
    labelPaddingBottom: 8,
    borderRadius: 4,
    labelFontFamily: 'jiotype-medium',
    labelColor: Colors.LABEL_GREY as ColorOptions,
    labelFontSize: 12,
    fontSize: 12,
    selectionColor: 'BLUE',
    paddingHorizontal: 8,
    paddingVertical: 8,
    placeholderTextColor: Colors.FONT_BLACK as ColorOptions,
    color: Colors.FONT_BLACK as ColorOptions,
    borderColor: Colors.BORDER_LIGHT_BLUE as ColorOptions,
    focusBorderColor: Colors.BORDER_LIGHT_BLUE as ColorOptions,
    fontFamily: 'jiotype-medium',
  } as TextInputNewProps,
}
